export interface CSVOptions {
  filename: string;
}

export type TableData = Array<Record<string, any>>;

/**
 * Converts table data to CSV format
 * @param data Array of objects representing table rows
 * @returns CSV formatted string
 */
const convertToCSV = (data: TableData): string => {
  if (data.length === 0) return "";

  const headers: string[] = Object.keys(data[0]);
  const csvRows: string[] = [headers.join(",")];

  for (const row of data) {
    const values: string[] = headers.map((header) => {
      const cellValue = row[header];
      if (cellValue == null) return "";

      // Handle values containing commas or quotes
      const stringValue = String(cellValue);
      if (stringValue.includes(",") || stringValue.includes('"')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }
      return stringValue;
    });
    csvRows.push(values.join(","));
  }

  return csvRows.join("\n");
};

/**
 * Downloads table data as a CSV file
 * @param data Array of objects representing table rows
 * @param options Download options including filename
 */
export const downloadAsCSV = (data: TableData, options: CSVOptions): void => {
  const csv: string = convertToCSV(data);
  const blob: Blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const filename: string = options.filename.endsWith(".csv")
    ? options.filename
    : `${options.filename}.csv`;

  const link: HTMLAnchorElement = document.createElement("a");
  if (link.download !== undefined) {
    const url: string = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};
